import {
  ChartRow,
  ChartRowElement,
  ChartRowGroup,
  ChartSubsection,
  ChartSubsectionContent,
  ChartSubsectionHeader,
} from "modules/charts-shared";
import { RADIOLOGY_GRID_COLUMNS } from "../radiology-chart/constants";
import { RadiologyInterpretationProps } from "../radiology-chart/types";

function F016Interpretation(props: RadiologyInterpretationProps) {
  const {
    index,
    chartCode,
    encounterId,
    sectionId,
    sectionCode,
    sectionSubCode,
    onRemoveElement,
  } = props;

  const sectionDelimiter = `rad.${index}.${chartCode}${sectionId}${sectionCode}${sectionSubCode}`;

  return (
    <ChartSubsection
      header={
        <ChartSubsectionHeader
          showNotesBtn
          showDeleteBtn
          chartId={chartCode}
          encounterId={encounterId}
          sectionId={sectionCode}
          showInteractions={false}
          subsectionId={`${sectionSubCode}_Q001`}
          subsectionLabel="Sacrum"
          onDeleteSubSection={() => onRemoveElement(sectionId)}
        />
      }
      content={
        <ChartSubsectionContent>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement
                label="Sacrum:"
                name={`${sectionDelimiter}Q001A001`}
                type="cross-option"
              />
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="transverse:"
                name={`${sectionDelimiter}Q001A002`}
                type="cross-option"
              />
              <ChartRowElement
                label="displaced:"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A003`}
                type="cross-option"
              />
              <ChartRowElement
                label="ant"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A004`}
                type="cross-option"
              />
              <ChartRowElement
                label="post"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A005`}
                type="cross-option"
              />
              <ChartRowElement
                label="upper-comminuted"
                name={`${sectionDelimiter}Q001A006`}
                type="cross-option"
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A007`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="vertical fx thru:"
                name={`${sectionDelimiter}Q001A008`}
                type="cross-option"
              />
              <ChartRowElement
                label="ala"
                name={`${sectionDelimiter}Q001A009`}
                type="cross-option"
              />
              <ChartRowElement
                label="foramen"
                name={`${sectionDelimiter}Q001A010`}
                type="cross-option"
              />
              <ChartRowElement
                label="spinal canal"
                name={`${sectionDelimiter}Q001A011`}
                type="cross-option"
              />
              <ChartRowElement
                label="displaced:"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A012`}
                type="cross-option"
              />
              <ChartRowElement
                label="mild"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A013`}
                type="cross-option"
              />
              <ChartRowElement
                label="Galeazzi’s"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A014`}
                type="cross-option"
              />
              <ChartRowElement
                label="severe"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A015`}
                type="cross-option"
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A016`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                name={`${sectionDelimiter}Q001A017`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
        </ChartSubsectionContent>
      }
    />
  );
}

export { F016Interpretation };
